export function formatAxisValue(value: number): string {
  return value.toFixed(1);
}

export function formatTooltipValue(value: number, prefix: string = '', suffix: string = ''): string {
  return `${prefix}${value.toFixed(1)}${suffix}`;
}